import { render, staticRenderFns } from "./customFormBuildList.vue?vue&type=template&id=be1aaf10"
import script from "./customFormBuildList.vue?vue&type=script&lang=js"
export * from "./customFormBuildList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports